import store from './store';
import login from './auth';

export default {
    store,
    login,
};



// WEBPACK FOOTER //
// ./src/script/index.js